module.exports = __webpack_public_path__ + "img/chevron-double-right.c059e87c.svg";